// apps/client/src/world/objects/house.ts — resident and villager houses: the `house` builder's KayKit cottages (revision 10, D-04), static.
// No update: when level, roof, construction or occupant change, the outdoor scene builds the view again and swaps it.
import { friendColors } from '@whiskerton/content';
import type { HouseState } from '@whiskerton/shared';
import * as THREE from 'three';
import type { ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['house'],
  async build(obj, ctx) {
    const state = obj.state as HouseState;
    const owner = state.occupant?.kind === 'resident' ? ctx.residents[state.occupant.id] : undefined;
    const o = await ctx.assets.model(obj.catalogId, {
      level: state.level, roof: state.roof ?? '', friendDye: owner ? friendColors[owner.color].dye : '', building: state.building,
      resident: state.occupant?.kind === 'resident',                 // revision 9 item 3: M1-T14's fence and flower bed
    });
    // The builder marks its chimney on its own root, which the asset service wraps: lift it into this view's frame for the smoke FX.
    o.updateMatrixWorld(true);
    let chimney: THREE.Vector3 | undefined;
    o.traverse((c) => {
      const v = c.userData.chimney as THREE.Vector3 | undefined;
      if (!chimney && v instanceof THREE.Vector3) chimney = o.worldToLocal(c.localToWorld(v.clone()));
    });
    if (chimney) o.userData.chimney = chimney;
    o.userData.static = true;
    return o;
  },
};
